<template>
<div class="login-page">
    <img v-if="refreshDom" class="login-bg" :src="file[fileId]"/>
    <div class="forget-main">
      <button @click="back" class="forget-back">x</button>
      <div class="forget-title">{{ title }}</div>
      <div class="forget-info" v-if="showForm2">
        <b-container fluid>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'number') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="number" class="forget-input"></b-form-input>
            </b-col>
          </b-row>
        </b-container>
        <div class="forget-buttong">
            <b-button class="forget-button" variant="outline-light" @click="reset">{{ $t('Common.reset') }}</b-button>
            <b-button class="forget-button" variant="outline-light" @click="submit">{{ $t('Common.submit') }}</b-button>
        </div>
      </div>
      <div class="forget-info" v-if="showForm1">
        <div class="forget-subtitle">{{ $t('Auth.reseting', [this.number]) }}</div>
        <div class="forget-explain">*{{ $t('Auth.atLeast') }}</div>
        <b-container fluid>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseInput') }}{{ $t('Auth.inputItems.' + 'password') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="password" class="forget-input"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="forget-row">
            <b-col sm="4">
              <label>{{ $t('Auth.pleaseConfirm') }}:</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="confirm" class="forget-input"></b-form-input>
            </b-col>
          </b-row>
        </b-container>
        <div class="forget-buttong">
            <b-button class="forget-button" variant="outline-light" @click="reset">{{ $t('Common.reset') }}</b-button>
            <b-button class="forget-button" variant="outline-light" @click="submit2">{{ $t('Common.submit') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import axios from '@/api/config'
import { Alert } from 'vue-m-dialog'
import {
  forgetPassword,
  forgetPasswordTry,
  resetPassword
} from '@/api/authAPI'

const ContactCard = Vue.extend({
  name: 'ContactCard',
  data () {
    return {
      refreshDom: true,
      // selected: null,
      show: true,
      fileId: 1002,
      showForm1: false,
      showForm2: true,
      number: '',
      token: '',
      title: this.$t('Auth.forgetPassword'),
      password: '',
      confirm: ''
    }
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  mounted () {
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
    }
    this.token = this.$route.fullPath.split('?')[1]
    if (this.token) {
      document.getElementsByClassName('forget-main')[0].style.height = '500px'
      this.title = this.$t('Auth.resetPassword')
      this.showForm2 = false
      this.showForm1 = true
      let formData = new FormData()
      formData.append('token', this.token)
      axios.post(forgetPasswordTry, formData,
        {
          transformRequest: [function (newData, headers) {
            return newData
          }]
        })
        .then((res) => {
          if (res.data.error === '01') {
            Alert.alert(this.$t('Auth.submitSuccess2'))
            this.$router.push({
              name: 'login'
            })
            this.reset()
          } else if (res.data.error === '02') {
            this.$router.push({
              name: 'login'
            })
            if (this.$route.name === 'login') {
              Alert.alert(this.$t('Auth.tokenExpire'))
            }
            this.reset()
          } else {
            this.number = res.data.number
          }
        })
    }
  },
  watch: {
    isFileChange () {
      this.refresh()
    }
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    },
    reset () {
      this.number = ''
    },
    submit () {
      if (this.number !== '') {
        let formData = new FormData()
        formData.append('number', this.number)
        axios.post(forgetPassword, formData,
          {
            transformRequest: [function (newData, headers) {
              return newData
            }]
          })
          .then((res) => {
            if (res.data.error === '01') {
              Alert.alert(this.$t('Auth.submitSuccess2'))
              this.$router.push({
                name: 'login'
              })
              this.reset()
            }
            if (res.data.error === '02') {
              Alert.alert(this.$t('Auth.submitFail'))
            }
          })
      } else {
        Alert.alert(this.$t('Auth.submitFail'))
      }
    },
    submit2 () {
      if (this.password.length < 6) {
        Alert.alert(this.$t('Auth.atLeast'))
      } else {
        if (this.password !== this.confirm) {
          Alert.alert(this.$t('Auth.notSame'))
        } else {
          let formData = new FormData()
          formData.append('password', this.password)
          formData.append('token', this.token)
          axios.post(resetPassword, formData,
            {
              transformRequest: [function (newData, headers) {
                return newData
              }]
            })
            .then((res) => {
              if (res.data.massage === 'ok') {
                Alert.alert(this.$t('Auth.submitSuccess3'))
                this.$router.push({
                  name: 'login'
                })
                this.reset()
              }
              if (res.data.massage === 'xok') {
                Alert.alert(this.$t('Auth.submitFail2'))
              }
            })
        }
      }
    },
    back () {
      this.$router.push({
        name: 'login'
      })
    }
  }
})
export default ContactCard
</script>

<style>
.login-page {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}
.login-bg {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.forget-back {
  position: absolute;
  font-size: 20px;
  color: white;
  font-weight: 700;
  z-index: 10;
  border: 1px solid white;
  border-radius: 50%;
  height: 38px;
  width: 38px;
  top: 40px;
  left: 30px;
  background-color: #FFFFFF00;
}
.forget-back:focus {
  outline: none;
}
.forget-main {
    position: absolute;
    top: 5%;
    left: 50%;
    width: 60%;
    height: 280px;
    transform: translateX(-50%);
    z-index: 2;
    padding: 30px;
    padding-bottom: 20px;
    background-color: #ffffff28;
    border-radius: 25px;
    transition: all 0.5s ease-in-out;
    text-align: center;
}
.forget-title {
    z-index: 1;
    font-size: 40px;
    color: white;
}
.forget-subtitle {
    z-index: 1;
    font-size: 30px;
    color: white;
}
.forget-vendors {
  /* width: 90%; */
  z-index: 10;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.5);
}
.forget-explain {
    color: white;
    font-size: 16px;
    margin-top: 5px;
}
.forget-info {
    margin-top: 40px;
    /* text-align: left; */
    width: 80%;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.forget-row {
  color: #eeeeee;
  font-size: 20px;
  margin-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
}
.forget-inputslct {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-input {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-inputarea {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
  height: 350px;
}
.forget-inputarea:focus {
  border: 0;
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
  height: 350px;
}
.forget-input:focus {
  font-size: 18px;
  color: #666666;
  background-color: rgba(255, 255, 255, 0.3);
}
.forget-buttong {
  margin-top: 20px;
}
.forget-button {
  margin: 10px;
}
</style>
